<template>
<div class="footer-padding">

  <div class="column tile is-parent is-vertical is-12">

    <Tile v-for="(skills, category) in skillsPerType"
      :key="category" :title="category"
      subtitle="Select the options and adjust the experience level">
      <div class="columns">
        <TagSelect class="column" :items="skills"
        :activeList="activeSkillNames" @toggle="(s) => toggleSkill(s)"/>

        <div class="column">
          <LevelSelect :label="skill.name" v-model="skill.level"
          v-for="skill in groupedEdittedSkills[category]" :key="skill.name"
          horizontal/>
        </div>
      </div>
    </Tile>

    <Tile title="Other" subtitle="Select the options and adjust the experience level"
      v-if="isLoggedInOfTypes(['on_dock'])">
      <div class="columns">
        <div class="column">
          <b-taginput
            :value="groupedEdittedSkills['Other'].map(s => s.name)"
            @add="toggleSkill"
            @remove="toggleSkill"
            icon="label"
            type="is-primary"
            placeholder="Add a skill">
          </b-taginput>
        </div>
        <div class="column">
          <LevelSelect :label="skill.name" v-model="skill.level"
          v-for="skill in groupedEdittedSkills['Other']" :key="skill.name"
          horizontal/>
        </div>
      </div>
    </Tile>
  </div>
    <Footer>
      <a :class="[
        'button', 'is-medium',
        'is-primary', loading && 'is-loading']"
        :disabled="!hasChanges"
        @click="save">
        Save
      </a>
    </Footer>
</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';
import Footer from '@/components/Footer';
import Tile from '@/components/Tile';
import LevelSelect from '@/components/LevelSelect';
import TagSelect from '@/components/TagSelect';

export default {
  components: {
    Footer,
    Tile,
    LevelSelect,
    TagSelect,
  },
  data() {
    return {
      edittedSkills: [],
      loading: false,
      activeCategory: null,
    };
  },
  computed: {
    ...mapState({
      profile: state => state.auth.user.profile,
      skills: state => state.content.skills,
      user: state => state.auth.user,
    }),
    ...mapGetters({
      skillToCategory: 'content/skillToCategory',
      isLoggedInOfTypes: 'auth/isLoggedInOfTypes',
    }),
    groupedEdittedSkills() {
      return this.edittedSkills.reduce((acc, s) => {
        acc[this.skillToCategory[s.name] || 'Other'].push(s);
        return acc;
      }, Object.keys(this.skills).reduce((acc, category) => {
        acc[category] = [];
        return acc;
      }, { Other: [] }));
    },
    skillsPerType() {
      const skillKeys = {
        crew: 'all',
        diver: ['Languages'],
        owner: ['Languages'],
        on_dock: ['Languages', 'Engineer On Board', 'Dock Services'],
        charterer: ['Languages'],
      }[this.user.type];
      if (skillKeys === 'all') {
        return this.skills;
      }
      return pick(this.skills, skillKeys);
    },
    hasChanges() {
      return !isEqual(this.profile.skills, this.edittedSkills);
    },
    activeSkillNames() {
      return this.edittedSkills.map(s => s.name);
    },
  },
  methods: {
    ...mapActions({
      updateProfile: 'auth/updateProfile',
    }),
    async save() {
      this.loading = false;
      try {
        await this.updateProfile({ id: this.profile.id, skills: this.edittedSkills });
      } catch (e) {
        this.$toast.open({
          message: 'Could not save the personal info',
          type: 'is-danger',
        });
        this.loading = false;
        return;
      }
      this.initialize();
      this.loading = false;
    },
    initialize() {
      this.edittedSkills = cloneDeep(this.profile.skills);
    },
    toggleSkill(skillName) {
      const existingIndex = this.edittedSkills.findIndex(
        edittedSkill => edittedSkill.name === skillName,
      );
      if (existingIndex !== -1) {
        this.edittedSkills.splice(existingIndex, 1);
      } else {
        this.edittedSkills.push({ name: skillName, level: 1 });
      }
    },
  },
  created() {
    this.initialize();
  },
};
</script>
